import { render, staticRenderFns } from "./CmgGroupOrderCreatePage.vue?vue&type=template&id=50a5bbec&scoped=true&lang=pug"
import script from "./cmg-group-order-create-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-group-order-create-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGroupOrderCreatePage.vue?vue&type=style&index=0&id=50a5bbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5bbec",
  null
  
)

export default component.exports